import React from "react"
import clsx from "clsx"
import { twMerge } from "tailwind-merge"

interface Props {
	label: string
	icon?: React.ReactNode
	iconPosition?: "left" | "right"
	onClick?: () => void
	className?: string
}

const Pill: React.FC<Props> = ({ label, icon, iconPosition = "left", onClick, className }) => {
	const isClickable = Boolean(onClick)
	const iconDirectionClass = icon && iconPosition === "right" ? "flex-row-reverse" : "flex-row"

	const pillClasses = twMerge(
		clsx(
			"flex items-center gap-x-2 justify-center rounded-4 py-1",
			isClickable && "cursor-pointer active:opacity-80",
			iconDirectionClass,
			className,
		),
	)

	return (
		<div onClick={onClick} className={pillClasses}>
			{icon && <span className="h-4 w-4">{icon}</span>}
			<span>{label}</span>
		</div>
	)
}

export default Pill
